// module
import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
// services
import BrokerageAndCharges from 'modules/BrokerageAndCharges';
import LocaleService from 'modules/Localization';
// store
import { useStore } from 'modules/Stores';
// components
import { ChevronDownIcon, ChevronUpIcon, LoadingBlock, Text, View } from '@upstox/upstox-ui';
import { ExtractedChargesData } from 'modules/BrokerageAndCharges/typings';
import EstimationChargesError from '../EstimationChargesError/EstimationChargesError';
import EstimationChargesDetails from '../EstimationChargesDetails/EstimationChargesDetails';
// typings
import { Props } from './typings';
// styles
import * as css from './styles';

const EstimatedCharges: React.FC<Props> = ({ basketOrderData }) => {
  const [toggle, setToggle] = useState(false);
  const [chargesData, setChargesData] =
    useState<ExtractedChargesData | undefined>(undefined);

  const { getError, clearError } = useStore('ErrorStore');
  const { getLoading } = useStore('LoadingStore');

  const isError = getError('GET_CHARGES');
  const isPreRiskLoading = getLoading('GET_CHARGES');

  const basketOrderQuantity = basketOrderData.length.toString();

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const fetchChargesData = useCallback(async () => {
    clearError('GET_CHARGES');
    const charges = await
      BrokerageAndCharges.getBasketOrderCharges(basketOrderData);
    if (charges !== 'error') {
      setChargesData(charges);
    }
  }, [basketOrderData, clearError]);

  useEffect(() => {
    fetchChargesData();
  }, []);

  if (isPreRiskLoading) {
    return (
      <LoadingBlock height={56} width={432} />
    );
  }

  return (
    <View css={css.container}>
      <View css={css.header}>
        <View css={css.totalCharges}>
          <View css={css.toggleContainer} onClick={handleToggle}>
            <Text size="s" weight="bold">{LocaleService.translate('ESTIMATED_CHARGES')}</Text>
            {chargesData && (
              <View>
                {toggle
                ? <ChevronUpIcon css={css.showMoreLessArrow} />
                : <ChevronDownIcon css={css.showMoreLessArrow} />}
              </View>
            )}
          </View>
          <Text size="s" weight="bold">
            {chargesData ? `₹ ${chargesData.total}` : LocaleService.translate('FAILED_TO_LOAD')}
          </Text>
        </View>
        <Text size="s" color="text.2">{LocaleService.translate('BASKET_ORDER_QUANTITY', basketOrderQuantity)}</Text>
      </View>

      {toggle && chargesData && (
        <EstimationChargesDetails chargesData={chargesData} />
      )}

      {isError !== undefined && (
        <EstimationChargesError onRetry={fetchChargesData} />
      )}

    </View>
  );
};

export default observer(EstimatedCharges);
